import React, { useRef } from "react";
import {
  DropZoneContainer,
  FileName,
  FileInput,
  FileSize,
  FileTypeIcon,
  PreviewContent,
  PreviewInfo,
  PreviewMedia,
  ReplaceButton,
} from "../styles";

export const MediaDropZone = ({
  file,
  previewUrl,
  fileTypeDisplayName,
  formattedFileSize,
  onFile,
  onRemove,
}) => {
  const inputRef = useRef(null);

  if (file) {
    const isImage = file.type.startsWith("image/");
    const isVideo = file.type.startsWith("video/");

    return (
      <div
        style={{
          border: "1px solid #d1fae5",
          borderRadius: 10,
          padding: "0.75rem 1rem",
          backgroundColor: "#f0fdf4",
          display: "flex",
          alignItems: "center",
          gap: "0.75rem",
        }}
      >
        <PreviewMedia style={{ width: 56, height: 56, borderRadius: 8, flexShrink: 0 }}>
          {isImage && <img src={previewUrl} alt="preview" />}
          {isVideo && <video src={previewUrl} />}
          {!isImage && !isVideo && (
            <FileTypeIcon style={{ fontSize: "1.5rem" }}>📄</FileTypeIcon>
          )}
        </PreviewMedia>

        <PreviewContent
          style={{ flex: 1, flexDirection: "column", gap: "0.15rem", alignItems: "flex-start" }}
        >
          <PreviewInfo>
            <FileName title={file.name}>{file.name}</FileName>
            <FileSize>
              {fileTypeDisplayName} · {formattedFileSize}
            </FileSize>
          </PreviewInfo>

          <ReplaceButton
            type="button"
            onClick={() => {
              onRemove();
              setTimeout(() => inputRef.current?.click(), 50);
            }}
          >
            Eliminar / Reemplazar
          </ReplaceButton>
        </PreviewContent>

        <FileInput
          ref={inputRef}
          type="file"
          accept=".jpg,.jpeg,.png,.mp4,.pdf"
          style={{
            display: "none",
            position: "static",
            opacity: 1,
            width: "auto",
            height: "auto",
          }}
          onChange={onFile}
        />
      </div>
    );
  }

  return (
    <DropZoneContainer style={{ minHeight: 90, padding: "1rem 1.5rem", gap: "0.25rem" }}>
      <FileInput type="file" accept=".jpg,.jpeg,.png,.mp4,.pdf" onChange={onFile} />
      <span style={{ fontSize: "1.5rem" }}>🖼️</span>
      <span style={{ fontSize: "0.85rem", fontWeight: 600, color: "#374151" }}>
        Arrastra o haz clic para subir
      </span>
      <span style={{ fontSize: "0.75rem", color: "#9ca3af" }}>
        JPG, PNG, MP4, PDF · Máx. 10 MB
      </span>
    </DropZoneContainer>
  );
};
